module.exports = __webpack_public_path__ + "static/media/aipimcarneseca.93101b08.webp";